export const ViewCard = ({ title, subtitle, info, children, height = 260 }) => (
  <section className="rounded-2xl border border-f1-border bg-f1-surface overflow-hidden flex flex-col">
    <header className="px-5 pt-5 pb-3 flex items-start justify-between gap-3">
      <div className="min-w-0">
        <h3 className="text-sm font-semibold tracking-tight text-f1-text">{title}</h3>
        {subtitle && <p className="text-xs text-f1-muted mt-0.5">{subtitle}</p>}
      </div>
      {info && <InfoIcon info={info} />}
    </header>
    <div className="relative w-full" style={{ height: `${height}px` }}>
      {children}
    </div>
  </section>
);

export const InfoIcon = ({ info }) => (
  <span className="relative group shrink-0">
    <button
      type="button"
      aria-label="About this view"
      className="w-5 h-5 rounded-full border border-f1-border text-[10px] text-f1-muted hover:text-f1-text hover:border-f1-muted focus:outline-none focus:ring-1 focus:ring-f1-red"
      tabIndex={0}
    >
      i
    </button>
    <span
      role="tooltip"
      className="invisible opacity-0 group-hover:visible group-hover:opacity-100 group-focus-within:visible group-focus-within:opacity-100 transition-opacity absolute right-0 top-7 z-20 w-72 max-w-[16rem] sm:max-w-[18rem] rounded-lg border border-f1-border bg-f1-surface2 p-3 text-[11px] leading-snug text-f1-text shadow-lg pointer-events-none"
    >
      {info}
    </span>
  </span>
);
